import axios from "axios";
import { API_END_POINT } from "../../../constants/api";

const authConfig = () => ({
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("usertoken")}`,
  },
});

export function getProgramsBySizer(sizerId, companyId) {
  return axios.get(
    `${API_END_POINT}/api/sizer/program/get/${sizerId}/${companyId}`,
    authConfig()
  );
}

export function getAllProgramsByCompany(companyId) {
  return axios.get(
    `${API_END_POINT}/api/sizer/program/company/${companyId}`,
    authConfig()
  );
}

export function getProgramById(programId, companyId) {
  return axios.get(
    `${API_END_POINT}/api/sizer/program/get-one/${programId}/${companyId}`,
    authConfig()
  );
}

export function getProgramYarnHistory(companyId) {
  return axios.get(
    `${API_END_POINT}/api/sizer/sizer-program-yarn-history/get/${companyId}`,
    authConfig()
  );
}

export function getCompanySendYarn(companyId) {
  return axios.get(
    `${API_END_POINT}/api/sizer/yarn/send-yarn/company/${companyId}`,
    authConfig()
  );
}

export function registerSizerBill(billData) {
  return axios.post(
    `${API_END_POINT}/api/sizer/bill/register`,
    billData,
    authConfig()
  );
}

export function getSizerBills(companyId, sizerId) {
  const url = sizerId
    ? `${API_END_POINT}/api/sizer/bill/get/${companyId}/${sizerId}`
    : `${API_END_POINT}/api/sizer/bill/get/${companyId}`;
  return axios.get(url, authConfig());
}

export function mapSizerBillsForPaymentHistory(bills = []) {
  return (Array.isArray(bills) ? bills : []).map((bill, index) => ({
    ...bill,
    SNo: index + 1,
    key: bill._id || bill.bill_id || index,
    tarbackbeam:
      bill.tarbackbeam ||
      `${bill.tar || ""}/${bill.back_beam || bill.back_beam_size || ""}`,
    date: bill.bill_date || bill.date || "",
    payment: bill.ammount || bill.amount || bill.total_amount || 0,
  }));
}
